<mat-dialog-content class="mat-typography">
  <img [src]="previewCapture()" style="width: 100%" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="true" (click)="delete()">{{'Löschen' | translate:
    ['tmc-yard.widgets.registration-terminal.transport-registration-document-scan.preview-dialog.button.delete',
    translationService.language]}}</button>
  <button mat-stroked-button [mat-dialog-close]="true" (click)="close()" cdkFocusInitial>{{'Schließen' | translate:
    ['shared.action.close', translationService.language]}}</button>
</mat-dialog-actions>